export default __webpack_public_path__ + "static/media/Carrusel_01.693c1619.png";